import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "GrupoSanguineoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "GrupoSanguineoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexGrupoSanguineo(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'GrupoSanguineo', name: 'GrupoSanguineo', title: 'Grupo Sanguineo' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            gruposanguineos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            gruposanguineo: {},
            
        };
    },
    methods: {
     
        newGrupoSanguineo() {
            this.gruposanguineo = {};
            this.$refs['frm-gruposanguineo'].show();
            // console.log("hhhhola")
        },
        showGrupoSanguineo(id) {
            this.isLoading=true;
            this.ss.showGrupoSanguineo(id).then(
                (result) => {
                    let response = result.data;
                    this.gruposanguineo = response.data;
                    this.$refs['view-gruposanguineo'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editGrupoSanguineo() {
            this.$refs['frm-gruposanguineo'].show();
            this.$refs['view-gruposanguineo'].hide();
        },
        cancelGrupoSanguineo() {
            if (this.gruposanguineo.id) {
                this.$refs['view-gruposanguineo'].show();
            }
            this.$refs['frm-gruposanguineo'].hide();
        },
        saveGrupoSanguineo() {
            this.ss.storeGrupoSanguineo(this.gruposanguineo).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-gruposanguineo'].hide();
                    this.$refs['datatable-gruposanguineo'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteGrupoSanguineo() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyGrupoSanguineo(this.gruposanguineo)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-gruposanguineo'].hide();
                                this.$refs['datatable-gruposanguineo'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-gruposanguineo'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-gruposanguineo'].show();
        },
        changePassword() {
            this.password.GrupoSanguineo = this.gruposanguineo.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-gruposanguineo'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-GrupoSanguineo').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showGrupoSanguineo(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
